function toggleMute() {
  const id = event.currentTarget.dataset.targetId;
  const video = document.getElementById(id);

  if (video.muted) {
    video.muted = false;
  } else {
    video.muted = true;
  }

  const icons = event.currentTarget.querySelectorAll(`.icon`);
  icons.forEach((icon) => icon.classList.toggle(`icon--hidden`));
}
